import { Component, OnInit, Input } from '@angular/core';
import { DependenciaModel } from 'src/app/models/dependencia.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { reporteInformeVisitante } from 'src/app/models/reporteInformeVisitante.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { HttpResponseBase } from '@angular/common/http';
import { UtilService } from 'src/app/shared/services/util.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import * as moment from 'moment';
import { AdministrarFuncionarioDTO } from 'src/app/models/administrarFuncionario.model';

@Component({
    selector: 'app-reporte-compensacion-bicicleta',
    templateUrl: './reporte-compensacion-bicicleta.component.html',
    styleUrls: ['./../generar-reportes-funcionarios.component.scss']
})

export class ReporteCompensacionBicicletaComponent implements OnInit {

    @Input() public dependencia: DependenciaModel[];
    @Input() reporteInformeVisitante: reporteInformeVisitante[];

    public dominios: DetalleDominio[] = [];
    public filtroTipoDoc: string;
    public dominioTiposDocumento: DetalleDominio[] = [];
    public dominiosTipoVinculacion: DetalleDominio[] = [];
    public dominioSedes: DetalleDominio[] = [];
    public dominioEstado: DetalleDominio[] = [];
    public listaDependencias: any;
    public filtroDocumento: string;
    public filtroTipoVinculacion: string;
    public filtroSede: string;
    public filtroDependencia: string;
    public filtroEstado: string;
    public filtroFechaSolicitud: Date;
    public filtroFechaFin: Date;
    public placeholderDate: string;
    public funcionarios: AdministrarFuncionarioDTO[] = [];
    guardarCampoVinculacion: boolean;

    public validar = false;
    public datosArchivo: any;

    public listaDominios: string[] = [DominiosService.DOMINIO_TIPO_FUNCIONARIO,
        DominiosService.DOMINIO_TIPO_IDENTIFICACION, DominiosService.DOMINIO_SEDE,
        DominiosService.DOMINIO_ESTADO_INCENTIVO_BICICLETA];

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService
    ) { }

    ngOnInit() {

        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.consultarDominios();
    }

    /**
     * Consulta los dominios para traer el tipo de documento
     */
    public consultarDominios() {
        this.spinner.show();
        const serviceProvider = 'consultarDominios';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.postGenerico(url, this.listaDominios).subscribe(
            data => {
                this.dominios = data;
                this.filtrarDominios(this.dominios);
                this.spinner.hide();
            }, err => {
                this.catchException('Ocurrio un error en la consulta de los dominios');
            }
        );
    }

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    generarReporteCompensacionBicicleta() {

        this.spinner.show();

        if (this.filtroTipoDoc && !this.filtroDocumento) {
            this.validar = false;
            this.catchException('Por favor ingrese el “Número de documento”');
            return;
        }
        if (this.filtroDocumento && this.filtroDocumento.length > 0 && !/^([A-Z0-9])*$/.test(this.filtroDocumento)) {
            this.catchException('Por favor ingrese nuevamente un “Número de documento”');
            this.catchException('La información ingresada en “Número de documento”'
                + 'no corresponde con lo solicitado, por favor verifique');
            document.getElementById('numeroDocumento').focus();
            return;
        }
        if (this.filtroFechaSolicitud.getTime() > this.filtroFechaFin.getTime()) {
            this.catchException('La fecha de solicitud no puede ser mayor a la fecha final');
            return;
        }
        if (this.filtroTipoVinculacion === 'Ambos') {
            this.filtroTipoVinculacion = undefined;
            this.guardarCampoVinculacion = true;
        }
        const filtros = {
            filtroTipoDocumento: this.filtroTipoDoc,
            filtroDocumento: this.filtroDocumento,
            filtroTipoVinculacion: this.filtroTipoVinculacion,
            filtroDependencia: this.filtroDependencia,
            filtroSede: this.filtroSede,
            filtroEstado: this.filtroEstado,
            filtroFechaSolicitud: this.filtroFechaSolicitud,
            filtroFechaFin: this.filtroFechaFin
        };
        const serviceProvider = 'reporteCompensacionBicicleta';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url, filtros).subscribe(
            data => {
                this.datosArchivo = data;
                this.spinner.hide();
                this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
                this.descargarArchivo();
            }, err => {
                  if (err.status === 500) {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('El reporte no se ha podido generar');
                }
            }
        );

        if (this.guardarCampoVinculacion) {
            this.guardarCampoVinculacion = false;
            this.filtroTipoVinculacion = 'Ambos';
        }
    }

    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.datosArchivo.nombre, this.datosArchivo.archivo);
        this.spinner.hide();
    }

    /**
     * Método de control de Excepciones
     * @param error                 mensaje saliente respecto al error ocurrido
     * @param err: HttpResponseBase Tipo de error
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
        this.spinner.hide();
    }

    /**
     * Metodo que valida los campos obligatorios para porder habilitar el boton Generar Reporte
     */
    validacion() {

        if (this.filtroTipoDoc === 'undefined') {
            this.filtroTipoDoc = undefined;
        }
        if (this.filtroDocumento === '') {
            this.filtroDocumento = undefined;
        }
        if (this.filtroSede === 'undefined') {
            this.filtroSede = undefined;
        }
        if (this.filtroEstado === 'undefined') {
            this.filtroEstado = undefined;
        }
        if (this.filtroTipoVinculacion === 'undefined') {
            this.filtroTipoVinculacion = undefined;
        }
        if (this.filtroDependencia === 'undefined') {
            this.filtroDependencia = undefined;
        }
        if (this.filtroFechaSolicitud && this.filtroFechaFin
            && this.filtroSede && this.filtroEstado &&
            this.filtroDependencia) {
            this.validar = true;
        } else {
            this.validar = false;
        }
    }

    /**
     * Metodo encargado de filtrar los dominios por cada una de las listas de seleccion
     * @function {filtrarDominios}
     * @param  {type} dominios: DetalleDominio[] {description}
     * @return {type} {description}
     */
    filtrarDominios(dominios: DetalleDominio[]) {

        this.dominioTiposDocumento = dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio
            === DominiosService.DOMINIO_TIPO_IDENTIFICACION);
        this.dominiosTipoVinculacion = dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio
            === DominiosService.DOMINIO_TIPO_FUNCIONARIO);
        this.dominioSedes = dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio
            === DominiosService.DOMINIO_SEDE);
        this.dominioEstado = dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio
            === DominiosService.DOMINIO_ESTADO_INCENTIVO_BICICLETA);
    }

    /**
     * Metodo que realiza la consulta de las dependencias
     */
    obtenerDependencia() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDependencias';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy', 'sede=' + this.filtroSede]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, 
            queryParams), this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.listaDependencias = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No es posible obtener las dependencias');
            }
        );
    }
}
